import React from 'react';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {
  SERVER_DATA_VALIDATION_ERRORS,
  USER_FILE_UPLOAD_ERRORS,
  USYS_DATA_ATTRS,
} from '@packages/systems/users/constants';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';

const ERRORS_ID = Object.keys(USER_FILE_UPLOAD_ERRORS).map(
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly GENERIC: { readonly id: "GENERIC_ERROR"; readonly msg: "Upload failed. Something went wrong. Please retry."; readonly path: readonly ["data", "form", "GENERIC_ERROR"]; }; readonly TOO_LARGE: { ...; }; readonly TOO_SMALL: { ...; }; readonly TYPE: { ...; }; readonly REQUIRED: { ...; }; }'.
  (err) => USER_FILE_UPLOAD_ERRORS[err].id
);

const UserFormUploadErrorMsg = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const updatedClasses = classes.push('w-file-upload-error-msg');

    const errorsMsg = ERRORS_ID.reduce<Record<string, any>>((acc, errId) => {
      // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
      const msg = data?.form?.[errId] ?? 'Upload failed.';
      acc[errId] = msg;
      return acc;
    }, {});

    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const tempErrorId = data?.temp?.state ?? ERRORS_ID[0];
    const message = errorsMsg[tempErrorId];

    const errorsAttr = {
      [SERVER_DATA_VALIDATION_ERRORS.RequiredError]:
        errorsMsg[USER_FILE_UPLOAD_ERRORS.REQUIRED.id],
      [SERVER_DATA_VALIDATION_ERRORS.MaxSizeError]:
        errorsMsg[USER_FILE_UPLOAD_ERRORS.TOO_SMALL.id],
      [SERVER_DATA_VALIDATION_ERRORS.MinSizeError]:
        errorsMsg[USER_FILE_UPLOAD_ERRORS.TOO_LARGE.id],
      [SERVER_DATA_VALIDATION_ERRORS.ExtensionsError]:
        errorsMsg[USER_FILE_UPLOAD_ERRORS.TYPE.id],
      [SERVER_DATA_VALIDATION_ERRORS.DefaultError]:
        errorsMsg[USER_FILE_UPLOAD_ERRORS.GENERIC.id],
    } as const;

    const userAttr = {
      // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
      [USYS_DATA_ATTRS.field]: data?.users?.field ?? '',
    } as const;

    return (
      <div
        {...generateAttributes(attributes, updatedClasses)}
        {...errorsAttr}
        {...userAttr}
      >
        {message}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Error Message',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: false,
  render: UserFormUploadErrorMsg,
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Form'), typeName('UserFormUploadErrorMsg'))
  ),
});

export default config;
